import { FiltersPart } from './FiltersContext'
import FiltersList from './FiltersList'

export default function FiltersItem({ filter }: { filter: FiltersPart }) {

  return (
     <FiltersList filter={filter} />
  )
}
